import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, setDoc, type DocumentReference } from 'firebase/firestore';

export { type DocumentReference } from 'firebase/firestore';

const config = {
    apiKey: 'AIzaSyBN6utiu4qUeibE_NQQXsxJRE4RPbRLnsg',
    authDomain: 'braiins-academy.firebaseapp.com',
    projectId: 'braiins-academy',
    storageBucket: 'braiins-academy.appspot.com',
    messagingSenderId: '585656264478',
    appId: '1:585656264478:web:4eeaf189471301a7b1cb0f',
};
const app = initializeApp(config);

export const db = getFirestore(app);

export enum Score {
    yep = 2,
    meh = 1,
    nope = 0,
}

type FeedbackEntry = {
    score: string;
    message: string;
    page: {
        title: string;
        pathname: string;
        language: string;
        project: string;
        page: string;
        tab: string;
    };
    navigator: string;
    timestamp: number;
};
export function sendFeedback(score: Score, message: string) {
    const ref = collection(db, 'feedback');
    const [language, project, page, tab] = window.location.pathname.split('/').filter(Boolean);
    const data: FeedbackEntry = {
        score: Score[score],
        message,
        page: {
            title: document.title,
            pathname: window.location.pathname,
            language: language || '',
            project: project || '',
            page: page || '',
            tab: tab || '',
        },
        navigator: window.navigator.userAgent,
        timestamp: Math.floor(new Date().getTime() / 1e3),
    };
    return addDoc(ref, data);
}

export function updateFeedback(ref: DocumentReference, patch: Partial<FeedbackEntry>) {
    return setDoc(ref, patch, { merge: true });
}
